import { render, staticRenderFns } from "./ProductTypeFilter.vue?vue&type=template&id=6da5d74c&scoped=true&"
import script from "./ProductTypeFilter.vue?vue&type=script&lang=ts&"
export * from "./ProductTypeFilter.vue?vue&type=script&lang=ts&"
import style0 from "./ProductTypeFilter.vue?vue&type=style&index=0&id=6da5d74c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da5d74c",
  null
  
)

export default component.exports